import { AppState } from "store";
import { ParticipantTreeOptionsArgs } from "./types";

export const participantTreeOptionsSelector = ({
  participantTreeOptions,
}: AppState): ParticipantTreeOptionsArgs => {
  return participantTreeOptions.data;
};
